'use strict';

customerZone.run(['$rootScope', 'Session', 'utils', function($rootScope, Session, utils){
    $rootScope.$on(Session.PROFILE_CHANGED_EVENT, function(event, profile){
        if (!profile)
            utils.poll.cancelAll();
    });
}]);
